import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CustomProducts from "./CustomProducts/MCustomProducts";
import ProductFabrics from "./Fabrics/MProductFabrics";
import Products from "./MProducts";
import ProductSizes from "./Sizes/MProductSizes";
import ProductTypes from "./MProductTypes/MProductTypes";

export default function MProductsLayout() {
  /*   All States
   ********************************************* */
  const [active, setActive] = useState("products");

  const [searchParams, setSearchParams] = useSearchParams();

  /*   All Functions
   ********************************************* */
  const updateSearchParams = (newActive) => {
    // Update the search parameters in the URL with the new active tab
    setSearchParams({ active: newActive });
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    // Check if there is an active tab in the URL search params
    // If so, set the active state to that tab
    // If not, default to "products"
    // This allows the component to reflect the active tab based on the URL
    // This is useful for deep linking or when the user navigates directly to a specific tab
    // This will also update the URL when the active tab changes

    const activeTabParam = searchParams.get("active");
    if (activeTabParam) {
      setActive(activeTabParam);
    } else {
      updateSearchParams("products");
    }
    const activeTab = searchParams.get("active");
    if (activeTab) {
      setActive(activeTab);
    }
  }, [searchParams]);
  return (
    <div style={{ marginLeft: 260, height: "100vh" }}>
      <div className="pt-2 ms-2">
        <div>
          <button
            className={`btn ${
              active === "products" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("products");
            }}
          >
            Products
          </button>
          <button
            className={`btn ${
              active === "productTypes" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("productTypes");
            }}
          >
            Product Types
          </button>

          <button
            className={`btn ${
              active === "custom_products" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("custom_products");
            }}
          >
            Custom Products
          </button>

          <button
            className={`btn ${active === "sizes" ? "btn-primary" : "bg-white"}`}
            onClick={(e) => {
              updateSearchParams("sizes");
            }}
          >
            Sizes
          </button>
          <button
            className={`btn ${
              active === "fabrics" ? "btn-primary" : "bg-white"
            }`}
            onClick={(e) => {
              updateSearchParams("fabrics");
            }}
          >
            Fabrics
          </button>
        </div>
        <div className="p-2">
          {active === "products" && (
            <div>
              <Products />
            </div>
          )}
          {active === "custom_products" && (
            <div>
              <CustomProducts />
            </div>
          )}

          {active === "productTypes" && (
            <div>
              <ProductTypes />
            </div>
          )}
          {active === "sizes" && (
            <div>
              <ProductSizes />
            </div>
          )}
          {active === "fabrics" && (
            <div>
              <ProductFabrics />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
